import { FORM_ERROR_MSG } from '../../../../types/types';
import useAuth from '../../../../hooks/auth-hooks';
import { CARD_GROUP_FORM } from '../form-cardgroup-types';
import { showToast } from '../../../toasts';
import { getParameters } from '../../../../helpers/helpers';

import AwsUpdateCardGroup from '../../../../routes/update-card-group';

/**
 * Updates and existing card group
 * 
 * @returns void
 */
export const updateCardGroup = () => {
  if ( !CARD_GROUP_FORM.cgUpdateForm ) return;

  const { cgUpdateForm, cgPaymentMethod, cgHose, cgSubmitButton, cgName,cgMarginCents, cgTimeoutOverride, cgTerminaltax } = CARD_GROUP_FORM;
  
  const validateForm = (customerID: HTMLElement) => {
    cgUpdateForm.classList.add('was-validated');

    customerID === null ? FORM_ERROR_MSG.innerHTML = 'Please select a customer' : FORM_ERROR_MSG.innerHTML = '';

    return cgUpdateForm.checkValidity() &&
        cgPaymentMethod.getAttribute('data-value') != null &&
        cgHose.getAttribute('data-value') != null &&
        customerID != null;
  };

  const postAndRedirect = async (awsData: any) => {
    const { body } = await AwsUpdateCardGroup(awsData);

    if ( body ) {
      showToast('aafp_toast', `${cgName.value} group has been added`);
      setTimeout(() => {
        location.href = '/card-group/';
      }, 1500);
    }
  };

  cgUpdateForm.addEventListener('submit', event => {
    event.preventDefault();
    event.stopPropagation();

    const customerID = document.querySelector('[data-customer]') as HTMLElement;

    if( validateForm(customerID) ) {
      cgUpdateForm.classList.remove('was-validated');
      cgUpdateForm.classList.remove('form-control:valid');
      cgSubmitButton.classList.add('aafp_button-loading');
      FORM_ERROR_MSG.innerHTML = '';
      
      const { userId } = useAuth()!;
      const cardGroupID = getParameters('groupID');
      const hose = cgHose;

      const awsJsonData = {
        wpId: userId,
        cardGroupId: +cardGroupID,
        customerId: Number(customerID.getAttribute('data-customer')),
        cardGroupName: cgName.value,
        paymentMethod: String(cgPaymentMethod.getAttribute('data-value')),
        marginCents: cgMarginCents.valueAsNumber,
        hoseType: String(hose.getAttribute('data-value')),
        timeoutOverride: cgTimeoutOverride.checked === true ? '1' : '0',
        terminalTaxes: cgTerminaltax.checked === true ? '1' : '0'
      };

      postAndRedirect(awsJsonData);
    } 
  });
}